<!--Laptop and Tablet Vew-->
<div
	fxLayout="column"
	class="primary-bg"
	ngClass.gt-xs="p-t-xxl p-b-xxl"
	ngClass.lt-sm="p-t-xl p-b-xl"
	fxLayoutGap="2%"
>
	<div fxLayout="row" fxLayoutAlign="center" ngClass="p-b-s p-t-l">
		<h2
			class="white-text text-align-center"
			i18n="@@starting-a-fundraiser_howtoStartAFundraiser"
		>
			Raise Funds In 4 Easy Steps
		</h2>
	</div>
	<div fxLayout.lt-sm="row">
		<div
			fxLayout="row"
			fxLayoutAlign="flex-start center"
			ngClass.gt-md="p-l-xxl m-l-l p-b-l"
			ngClass.md="p-l-xxl p-b-l"
			ngClass.sm="p-l-xl p-b-l"
			fxHide.lt-sm
		>
			<img
				fxFlex.sm="78%"
				fxFlex.gt-sm="75%"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/horizontalLineHomepage/public"
			/>
		</div>
		<div
			fxLayout="column"
			fxLayoutAlign="flex-start center"
			ngClass.gt-xs="p-l-l p-t-xl"
			ngClass.lt-sm="p-l-l p-t-s"
			fxHide.gt-xs
		>
			<img
				fxFlex="81%"
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/verticalLineHomepage/public"
			/>
		</div>
		<div
			fxLayout="row"
			fxLayoutAlign="center"
			ngClass.gt-xs="p-b-xl"
			ngClass.lt-sm="p-l-m p-r-m"
		>
			<div
				fxLayout.gt-xs="row"
				fxLayout.lt-sm="column"
				fxFlex.gt-sm="88%"
				fxFlex.sm="92%"
				fxLayoutGap.gt-sm="3%"
				fxLayoutGap.sm="5%"
				fxLayoutAlign="space-between flex-start"
			>
				<div fxFlex="23%" fxLayout="column">
					<div fxLayout="row">
						<span
							class="white-text mat-headline-6"
							i18n="@@starting_a_fundraiser_startFundraiser"
							>Start a fundraiser</span
						>
					</div>
					<div fxLayout="row">
						<span
							class="white-text inc-span-height"
							i18n="@@starting_a_fundraiser_startFundraiserContent"
							>Sign up on WhyDonate and create your fundraiser in minutes. Sign
							up as a person or an organization.</span
						>
					</div>
				</div>
				<div fxFlex="23%" fxLayout="column">
					<div fxLayout="row">
						<span
							class="white-text mat-headline-6"
							i18n="@@starting_a_fundraiser_shareFundraiser"
							>Share your fundraiser</span
						>
					</div>
					<div fxLayout="row">
						<span
							class="white-text inc-span-height"
							i18n="@@starting_a_fundraiser_shareFundraiserContent"
							>Sign up on WhyDonate and create your fundraiser in minutes. Sign
							up as a person or an organization.</span
						>
					</div>
				</div>
				<div fxFlex="23%" fxLayout="column">
					<div fxLayout="row">
						<span
							class="white-text mat-headline-6"
							i18n="@@starting_a_fundraiser_receiveDonation"
							>Receive the donations</span
						>
					</div>
					<div fxLayout="row">
						<span
							class="white-text inc-span-height"
							i18n="@@starting_a_fundraiser_receiveDonationContent"
							>The donations are paid out automatically to your bank account on
							a monthly basis without any platform cost.</span
						>
					</div>
				</div>
				<div fxFlex="23%" fxLayout="column">
					<div fxLayout="row">
						<span
							class="white-text mat-headline-6"
							i18n="@@starting_a_fundraiser_thankDonors"
							>Thank your donors</span
						>
					</div>
					<div fxLayout="row">
						<span
							class="white-text inc-span-height"
							i18n="@@starting_a_fundraiser_thankDonorsContent"
							>The donations are paid out automatically to your bank account on
							a monthly basis without any platform cost.</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
